import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const customStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=DM+Sans:wght@400;500&display=swap');
`;

export default function Privacy() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = customStyles;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0f1c 0%, #0d1525 100%)',
      fontFamily: "'DM Sans', sans-serif",
      color: 'white'
    }}>
      {/* Header */}
      <div style={{
        background: 'rgba(255,255,255,0.02)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        padding: '20px 40px'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
            <div style={{
              width: '36px',
              height: '36px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '18px'
            }}>
              ⚡
            </div>
            <span style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: '18px',
              fontWeight: '600',
              color: 'white'
            }}>
              BrainForge
            </span>
          </Link>
          <Link to="/" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
        </div>
      </div>

      {/* Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '60px 40px'
      }}>
        <h1 style={{
          fontFamily: "'Outfit', sans-serif",
          fontSize: '40px',
          fontWeight: '700',
          marginBottom: '12px'
        }}>
          Privacy Policy
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: '48px' }}>
          Last updated: December 2025
        </p>

        <div style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.06)',
          borderRadius: '16px',
          padding: '32px'
        }}>
          {[
            {
              title: '1. Information We Collect',
              content: 'We collect: account information (email, name), usage data (conversations, preferences), and API keys you provide. We do not access the content of your conversations beyond what is necessary to provide the service.'
            },
            {
              title: '2. How We Use Your Information',
              content: 'We use your information to: provide and improve our services, process payments, send important updates, and provide customer support. We do not sell your personal information.'
            },
            {
              title: '3. API Key Security',
              content: 'Your API keys are encrypted using AES-256 encryption before storage. Keys are only decrypted when needed to make API calls on your behalf. We never log or expose your API keys.'
            },
            {
              title: '4. Data Storage',
              content: 'Your data is stored securely on our servers. Conversations are associated with your account and can be deleted at any time. We use industry-standard security measures to protect your data.'
            },
            {
              title: '5. Third-Party Services',
              content: 'We integrate with third-party AI providers (Anthropic, OpenAI, xAI, DeepSeek). Your conversations are sent to these providers according to their respective privacy policies. We also use Stripe for payment processing.'
            },
            {
              title: '6. Cookies',
              content: 'We use essential cookies to maintain your session and preferences. We do not use tracking cookies for advertising purposes.'
            },
            {
              title: '7. Your Rights',
              content: 'You have the right to: access your personal data, correct inaccurate data, delete your account and associated data, and export your conversation history.'
            },
            {
              title: '8. Data Retention',
              content: 'We retain your data as long as your account is active. Upon account deletion, we remove your personal data within 30 days. Some data may be retained for legal compliance.'
            },
            {
              title: '9. Changes to This Policy',
              content: 'We may update this policy from time to time. We will notify you of significant changes via email or through the service.'
            },
            {
              title: '10. Contact Us',
              content: 'For privacy concerns or data requests, contact us at privacy@multipowerai.com.'
            }
          ].map((section, i) => (
            <div key={i} style={{ marginBottom: i < 9 ? '28px' : 0 }}>
              <h2 style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: '18px',
                fontWeight: '600',
                color: '#667eea',
                marginBottom: '12px'
              }}>
                {section.title}
              </h2>
              <p style={{
                color: 'rgba(255,255,255,0.7)',
                lineHeight: '1.7',
                fontSize: '15px'
              }}>
                {section.content}
              </p>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: '40px',
          display: 'flex',
          gap: '24px',
          justifyContent: 'center'
        }}>
          <Link to="/terms" style={{ color: '#667eea', textDecoration: 'none', fontSize: '14px' }}>
            Terms of Service
          </Link>
          <Link to="/refund-policy" style={{ color: '#667eea', textDecoration: 'none', fontSize: '14px' }}>
            Refund Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
